import { render, staticRenderFns } from "./GiftRecipient.vue?vue&type=template&id=71cc8398&scoped=true"
import script from "./GiftRecipient.vue?vue&type=script&lang=js"
export * from "./GiftRecipient.vue?vue&type=script&lang=js"
import style0 from "./GiftRecipient.vue?vue&type=style&index=0&id=71cc8398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc8398",
  null
  
)

export default component.exports